"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, FC, PropsWithChildren, useContext, useState } from "react";
type ChatBotContextValue = {
  closeChatBot: () => void;
  isChatBotOpen: boolean;
  openChatBot: () => void;
};
const ChatBotContext = createContext<ChatBotContextValue | null>(null);
export const ChatBotProvider: FC<PropsWithChildren> = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  const [isChatBotOpen, setIsChatBotOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsChatBotOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const openChatBot = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsChatBotOpen(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const closeChatBot = t2;
  let t3;
  if ($[2] !== isChatBotOpen) {
    t3 = {
      closeChatBot,
      isChatBotOpen,
      openChatBot
    };
    $[2] = isChatBotOpen;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== t3) {
    t4 = <ChatBotContext.Provider value={t3}>{children}</ChatBotContext.Provider>;
    $[4] = children;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export const useChatBotContext = () => {
  const context = useOptionalChatBotContext();
  if (!context) {
    throw new Error("useChatBotContext must be used within ChatBotProvider");
  }
  return context;
};
export const useOptionalChatBotContext = () => {
  return useContext(ChatBotContext);
};